"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddEditParticipantToProjectModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const PromiseUtils_1 = require("src/hello_assets/src/components/system/util/PromiseUtils");
const TextTruncated_1 = require("src/hello_assets/src/components/ui/common/common/TextTruncated");
const principal_1 = require("@dfinity/principal");
const ProjectParticipantsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectParticipantsProvider");
const useForm_1 = __importDefault(require("antd/lib/form/hooks/useForm"));
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
/*specific*/
const PARTICIPANT_PRINCIPAL_MAXLENGTH = 63;
const PARTICIPANT_NAME_MAXLENGTH = 200;
const formRules = {
    name: [{ required: true, message: "Name is required" }],
    principal: [{
            required: true,
            message: "Principal is required",
        }, {
            validator: async (rule, value) => {
                if (lodash_1.default.isEmpty(value)) {
                    return Promise.resolve();
                }
                try {
                    const principalFromValue = principal_1.Principal.fromText(value);
                    if (principalFromValue.isAnonymous()) {
                        return Promise.reject(new Error('Non anonymous principal is required'));
                    }
                    return Promise.resolve();
                }
                catch (e) {
                    return Promise.reject(new Error('Valid principal is required'));
                }
            }
        }]
};
const modalButtonsPropsInitialValue = {
    ok: { disabled: true },
    cancel: {}
};
const AddEditParticipantToProjectModalComponent = (props) => {
    const projectParticipantsContext = (0, ProjectParticipantsProvider_1.useProjectParticipantsContext)();
    const [form] = (0, useForm_1.default)();
    // const formRef = useRef();
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const submitForm = (0, react_1.useCallback)(args => {
        if (!modalButtonProps.ok.disabled) {
            form && form.submit();
        }
    }, [modalButtonProps.ok.disabled]);
    const isCreate = lodash_1.default.isEmpty(props.participantView);
    const initialValues = {
        principal: isCreate ? "" : props.participantView ? props.participantView.principal.toText() : "",
        name: isCreate ? "" : props.participantView ? props.participantView.name : ""
    };
    const title = isCreate ?
        React.createElement(React.Fragment, null,
            "Invite to ",
            React.createElement(TextTruncated_1.TextTruncated, { text: props.projectView.projectName, length: 40 })) :
        React.createElement(React.Fragment, null, "Edit member");
    const okText = isCreate ? "Invite" : "Update";
    const addCancellable = (0, PromiseUtils_1.makeCancelableAsync)(async (participantPrincipal, participantName) => {
        return await projectParticipantsContext.management.addNewViewerParticipant(props.projectView.projectApiKey, participantPrincipal, participantName);
    });
    const updateCancellable = (0, PromiseUtils_1.makeCancelableAsync)(async (newParticipantName) => {
        return await projectParticipantsContext.management.updateParticipantName(props.projectView.projectApiKey, props.participantView.principal, newParticipantName);
    });
    const asyncAdd = async (formValues) => {
        try {
            const { principal, name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            try {
                const result = await addCancellable.runAsyncFunc(principal_1.Principal.fromText(principal), name);
                Analytics_1.Analytics.trackInviteMember();
                props.onDestroy();
            }
            catch (e) {
                const { isCanceled, error } = e;
                if (isCanceled) {
                    return;
                }
                else {
                    throw error;
                }
            }
        }
        catch (error) {
            console.error("ViewerParticipantToProjectModalComponent: add failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: ["Member cannot be invited. Please try again."] }]);
        }
    };
    const asyncUpdate = async (formValues) => {
        try {
            const { name } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            try {
                const result = await updateCancellable.runAsyncFunc(name);
                props.onDestroy();
            }
            catch (e) {
                const { isCanceled, error } = e;
                if (isCanceled) {
                    return;
                }
                else {
                    throw error;
                }
            }
        }
        catch (error) {
            console.error("ViewerParticipantToProjectModalComponent: update failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            //update errors
            form && form.setFields([{ name: "name", errors: ["Member cannot be updated. Please try again."] }]);
        }
    };
    const onFormFieldsChange = (changedFields, allFields) => {
        let valid = true;
        for (const idx in allFields) {
            const field = allFields[idx];
            if (field.errors && field.errors.length > 0) {
                valid = false;
            }
        }
        setModalButtonProps({
            ok: { disabled: !valid }
        });
    };
    const onFormFinish = async (values) => {
        if (isCreate) {
            await asyncAdd(values);
        }
        else {
            await asyncUpdate(values);
        }
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        if (form) {
            const values = form.getFieldsValue();
            await onFormFinish(values);
        }
    };
    return React.createElement(antd_1.Modal, { width: 550, closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, okText: okText, onOk: onOk, okButtonProps: modalButtonProps.ok, cancelButtonProps: modalButtonProps.cancel, className: "ug-modal" },
        React.createElement(antd_1.Form, { form: form, layout: "vertical", hideRequiredMark: true, initialValues: initialValues, onFinish: onFormFinish, onFieldsChange: onFormFieldsChange },
            React.createElement(antd_1.Form.Item, { name: "principal", label: "Principal", rules: formRules.principal },
                React.createElement(antd_1.Input, { autoFocus: isCreate, disabled: !isCreate, maxLength: PARTICIPANT_PRINCIPAL_MAXLENGTH, onPressEnter: submitForm })),
            React.createElement(antd_1.Form.Item, { name: "name", label: "Name", rules: formRules.name },
                React.createElement(antd_1.Input, { autoFocus: !isCreate, maxLength: PARTICIPANT_NAME_MAXLENGTH, onPressEnter: submitForm }))));
};
exports.AddEditParticipantToProjectModalComponent = AddEditParticipantToProjectModalComponent;
